import * as React from 'react';
import { formatTimestamp } from '@bytebrand/fe-ui-core-autobahn/utils';
import styles from './CarInvoices.styl';
class ProductInvoises extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "onPDFClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                this.props.getUrl(event.currentTarget.dataset.url, event.currentTarget.dataset.date);
            }
        });
        Object.defineProperty(this, "onAdditionalServicesTableArrowClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { tablesDateKeys } = this.state;
                const dateKey = event.currentTarget.dataset.date;
                const isInArray = tablesDateKeys.find((e) => e === dateKey);
                let newtablesDateKeys = [];
                if (isInArray) {
                    newtablesDateKeys = tablesDateKeys.filter((e) => e !== dateKey);
                }
                else {
                    newtablesDateKeys = tablesDateKeys.concat([dateKey]);
                }
                this.setState({ tablesDateKeys: newtablesDateKeys });
            }
        });
        Object.defineProperty(this, "toggleProductInvoiceOpenRow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { productInvoicesIds } = this.state;
                const productInvoicesId = parseInt(event.currentTarget.dataset.invoiceid, 10);
                const isInArray = productInvoicesIds.find((e) => e === productInvoicesId);
                let newProductInvoicesIds = [];
                if (isInArray) {
                    newProductInvoicesIds = productInvoicesIds.filter((e) => e !== productInvoicesId);
                }
                else {
                    newProductInvoicesIds = productInvoicesIds.concat([productInvoicesId]);
                }
                this.setState({ productInvoicesIds: newProductInvoicesIds });
            }
        });
        Object.defineProperty(this, "renderAdditionalServicesTable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (date, arrayOfInvoices, t) => {
                const { tablesDateKeys } = this.state;
                const shouldTableBeOpened = tablesDateKeys.find((e) => e === date);
                const sumOfMoney = arrayOfInvoices.reduce((accumulator, currentValue) => accumulator + currentValue.amount_untaxed, 0);
                const currencyName = arrayOfInvoices.length && arrayOfInvoices[0].currency_id[1];
                return (React.createElement("div", { className: styles.tableWrapper, key: date },
                    React.createElement("div", { className: styles.tableHeader },
                        React.createElement("span", { className: `${styles.headerItem} ${styles.width12dot3}` },
                            React.createElement("b", null, formatTimestamp({ timestamp: date, format: 'MMMM' })),
                            " ",
                            formatTimestamp({ timestamp: date, format: 'YYYY' })),
                        React.createElement("span", { className: `${styles.headerItem} ${styles.width60}` }, t('additionalServices')),
                        React.createElement("span", { className: `${styles.headerItem} ${styles.width25dot5}` },
                            t('totalBill'),
                            ": ",
                            React.createElement("b", null,
                                sumOfMoney,
                                " ",
                                currencyName)),
                        React.createElement("span", { className: `${styles.headerItem} ${!shouldTableBeOpened ? styles.arrowButton : styles.arrowDown}`, "data-date": date, onClick: this.onAdditionalServicesTableArrowClick })),
                    React.createElement("div", { className: `${!shouldTableBeOpened ? styles.carSellBodyFull : styles.carSellBodyEmpty}` },
                        React.createElement("div", { className: styles.tableSubHeader },
                            React.createElement("span", { className: styles.dateColumnName }, t('period')),
                            React.createElement("span", { className: styles.descriptionColumnName }, t('description')),
                            React.createElement("span", { className: styles.billNumberColumnName }, t('billNumberColumnName')),
                            React.createElement("span", { className: styles.sumColumnName }, t('sumColumnName')),
                            React.createElement("span", { className: styles.statusColumnName }, t('statusColumnName'))),
                        arrayOfInvoices.map((invoice) => this.renderAdditionalServicesRow(invoice)))));
            }
        });
        Object.defineProperty(this, "renderAdditionalServicesRow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (invoice) => {
                const { t } = this.props;
                const { productInvoicesIds } = this.state;
                const shouldInvoiceBeOpened = productInvoicesIds.find((e) => e === invoice.id);
                const isRedText = invoice.state === 'draft' || invoice.state === 'open' || invoice.state === 'cancel';
                return (React.createElement(React.Fragment, { key: invoice.id },
                    React.createElement("div", { className: styles.carSellRow },
                        React.createElement("span", { className: `${shouldInvoiceBeOpened ? styles.arrowDownFromLeft : styles.arrowLeft} `, "data-invoiceid": invoice.id, onClick: this.toggleProductInvoiceOpenRow }),
                        React.createElement("span", { className: `${styles.dateColumnValue}` }, invoice.date_invoice),
                        React.createElement("span", { className: `${styles.descriptionColumnName}` }, invoice.number),
                        React.createElement("span", { className: styles.billNumberColumnName }, invoice.number),
                        React.createElement("span", { className: styles.sumColumnName },
                            React.createElement("b", null,
                                invoice.amount_untaxed,
                                " ",
                                invoice.currency_id[1])),
                        React.createElement("span", { className: `${styles.statusColumnValue} ${isRedText ? styles.redText : styles.greenText}` }, t(invoice.state)),
                        React.createElement("span", { className: styles.pdfButton, "data-date": invoice.date_invoice, "data-url": invoice.pdf_download, onClick: this.onPDFClick })),
                    shouldInvoiceBeOpened ? (React.createElement("div", { className: styles.openedCarSellRow },
                        React.createElement("div", { className: styles.openedCarSellRowHeader },
                            React.createElement("span", { className: styles.mengeTitle }, t('amount')),
                            React.createElement("span", { className: styles.EinzelpreisTitle }, t('price')),
                            React.createElement("span", { className: styles.GesamtbetragTitle }, t('totalAmount'))),
                        invoice.invoice_line_ids.map((line) => (React.createElement("div", { className: styles.openedCarSellRowValues, key: line.id },
                            React.createElement("span", { className: styles.textValue }, line.name),
                            React.createElement("span", { className: styles.mengeValue }, line.quantity),
                            React.createElement("span", { className: styles.EinzelpreisValue },
                                line.price_subtotal,
                                " ",
                                invoice.currency_id[1]),
                            React.createElement("span", { className: styles.GesamtbetragValue },
                                line.price_total,
                                " ",
                                invoice.currency_id[1])))))) : null));
            }
        });
        this.state = {
            isCarSellTableShowed: true,
            additionalServices: true,
            productInvoicesIds: [],
            carInvoicesIds: [],
            tablesDateKeys: [],
            carsTablesDateKeys: [],
            shouldAllTablesBeClosed: false
        };
    }
    render() {
        const { date, arrayOfInvoices, t } = this.props;
        return (this.renderAdditionalServicesTable(date, arrayOfInvoices, t));
    }
}
export default ProductInvoises;
